import script from "./ModificarDatosAlumno.vue?vue&type=script&setup=true&lang=js"
export * from "./ModificarDatosAlumno.vue?vue&type=script&setup=true&lang=js"

import "./ModificarDatosAlumno.vue?vue&type=style&index=0&id=797b4045&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-797b4045"]])

export default __exports__